module.exports = __webpack_public_path__ + "static/dedicated_desk_2-8681c8f6d9a1129c8f8661a3d13b002f.jpg";